var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden lg:flex font-medium text-sm text-gray-600 mb-4"},[_c('div',{staticClass:"flex-1 px-4"},[_vm._v("Name")]),_c('div',{staticClass:"w-48 px-4"},[_vm._v("Email")]),_c('div',{staticClass:"w-32 px-4"},[_vm._v("Status")]),_c('div',{staticClass:"w-12 mr-2"})])
}]

export { render, staticRenderFns }